var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-c7e4aca8"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { key: 0 };
import dottoriAggiuntiveEdit from './dottoriAggiuntiveEdit.vue';
import dottoriModalConfidenzialita from './dottoriModalConfidenzialita.vue';
import CollapsibleItem from '@/layout/collapsible/CollapsibleItem.vue';
import { patientStore } from '@/store/patient';
import { storeToRefs } from 'pinia';
import { ref, onMounted, reactive } from 'vue';
import AlertModal from "@/components/AlertModalFeedback.vue";
import schemaCppPaziente from "@/../../EshJSLib/models/form/cppaziente.json";
import schemaCareProviders from "@/../../EshJSLib/models/form/careproviders.json";
import { saveDoctorsAssociated, updateConfidentialitaandVisibilita } from "@/../../EshJSLib/services/cppServices";
import Mail from "@/components/MailModal.vue";
import { sendEmail } from '@/../../EshJSLib/services/emailServices';
//Ref Element with HTML
export default /*#__PURE__*/ _defineComponent({
    __name: 'dottoriPage',
    props: {
        tipo: Number,
    },
    setup: function (__props) {
        var _this = this;
        var props = __props;
        var modalAddEditDottori = ref(null);
        var modalConfidenzialita = ref(null);
        var modalMail = ref(null);
        var alertModal = ref(null);
        var iTuoiDottori = ref(null);
        var ricercaDottori = ref(null);
        // Constant
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var showLoading = ref(false);
        var cppModel = reactive({});
        var alertMessage = ref('');
        var originalDoctors = ref([]);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                //iTuoiDottori.value = { ...schemaCppPaziente } as unknown as  CollapsableModel
                store.fetchAssociatedDoctors();
                store.fetchNotAssociatedDoctors();
                originalDoctors.value = patient.value['avalailable_doctors'];
                return [2 /*return*/];
            });
        }); });
        function saveAndRefreshAssociatedDoctors(userInput, row) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (userInput) {
                        showLoading.value = true;
                        saveDoctorsAssociated(row).then(function (x) {
                            store.fetchNotAssociatedDoctors();
                            store.fetchAssociatedDoctors().then(function () {
                                showLoading.value = false;
                                alertModal.value.openModal(alertMessage.value, false);
                                store.fetchNotAssociatedDoctors();
                            });
                        }).catch(function (error) {
                            showLoading.value = false;
                            alertModal.value.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
                        });
                    }
                    else {
                        store.fetchAssociatedDoctors();
                        store.fetchNotAssociatedDoctors();
                    }
                    return [2 /*return*/];
                });
            });
        }
        function actionAssociated(type, row, index, table) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var mailTemplate;
                return __generator(this, function (_b) {
                    mailTemplate = { topic: '', text: '', from: patient.value.paziente_email, to: row.email, name: '', recName: '' };
                    switch (type) {
                        case "envelope":
                            (_a = modalMail.value) === null || _a === void 0 ? void 0 : _a.openModal("Inviare Mail", mailTemplate).then(function (input) {
                                if (input) {
                                    sendMail(mailTemplate);
                                }
                            });
                            break;
                        case "lock":
                            cppModel.assegnazione_confidenzialita = row.assegnazione_confidenzialita;
                            cppModel.visibility = row.visibility;
                            cppModel.tags = row.tags;
                            cppModel.id_cpp = row.id_cpp;
                            cppModel.id_paziente = row.id_paziente;
                            cppModel.id_careprovider = row.id_careprovider;
                            modalAddEditDottori.value.openModal('', cppModel).then(function (input) {
                                if (input) {
                                    showLoading.value = true;
                                    updateConfidentialitaandVisibilita(cppModel).then(function () {
                                        showLoading.value = false;
                                        alertModal.value.openModal("Hai aggiornato con successo il livello di confidenzialità!", false);
                                        store.fetchAssociatedDoctors();
                                    });
                                }
                            });
                            break;
                        case 'trash':
                            alertMessage.value = 'Hai rimosso con successo il medico associato!';
                            alertModal.value.openModal("Sei sicuro di voler rimuovere il medico?", true).then(function (userInput) {
                                row.status = 'delete';
                                saveAndRefreshAssociatedDoctors(userInput, row);
                            });
                            break;
                    }
                    return [2 /*return*/];
                });
            });
        }
        function actionCareProviders(type, row, index, table) {
            return __awaiter(this, void 0, void 0, function () {
                var userInput, newAssociated;
                return __generator(this, function (_a) {
                    userInput = false;
                    newAssociated = {};
                    switch (type) {
                        case 'location-dot':
                            alert('to be done');
                            break;
                        case 'plus':
                            alertMessage.value = 'Hai aggiunto un dottore!';
                            newAssociated.status = "add";
                            newAssociated.assegnazione_confidenzialita = 1;
                            newAssociated.visibility = 2;
                            newAssociated.id_careprovider = row.id_cpp;
                            newAssociated.id_utente_cpp = row.id_utente;
                            newAssociated.id_utente = patient.value.id_paziente;
                            newAssociated.id_paziente = patient.value.id_paziente;
                            saveAndRefreshAssociatedDoctors(true, newAssociated);
                            break;
                    }
                    return [2 /*return*/];
                });
            });
        }
        function sendMail(mailTemp) {
            var params = JSON.stringify(mailTemp);
            sendEmail(params).then(function (response) {
                if ('status' in response) {
                    if (response.status == 200) {
                        alertModal.value.openModal('success', false);
                    }
                    else {
                        alertModal.value.openModal('fail', false);
                    }
                }
            }, function (error) {
                alertModal.value.openModal('fail', false);
            });
        }
        function search(word, check) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!word.trim()) return [3 /*break*/, 2];
                            return [4 /*yield*/, store.fetchNotAssociatedDoctors()];
                        case 1:
                            _a.sent();
                            patient.value['avalailable_doctors'] = originalDoctors.value.filter(function (datas) {
                                return datas.fullname.toLowerCase().includes(word.toLowerCase());
                            });
                            return [3 /*break*/, 3];
                        case 2:
                            store.fetchAssociatedDoctors();
                            store.fetchNotAssociatedDoctors();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            var _component_LoadingComponent = _resolveComponent("LoadingComponent");
            return (_unref(patient))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(dottoriAggiuntiveEdit, {
                        ref_key: "modalAddEditDottori",
                        ref: modalAddEditDottori
                    }, null, 512),
                    _createVNode(dottoriModalConfidenzialita, {
                        ref_key: "modalConfidenzialita",
                        ref: modalConfidenzialita
                    }, null, 512),
                    _createVNode(Mail, {
                        ref_key: "modalMail",
                        ref: modalMail
                    }, null, 512),
                    _createVNode(CollapsibleItem, {
                        data: _unref(schemaCppPaziente),
                        onRowActions: _cache[0] || (_cache[0] = function (n, r, i) { return actionAssociated(n, r, i, 'CppPaziente'); })
                    }, null, 8, ["data"]),
                    _createVNode(CollapsibleItem, {
                        data: _unref(schemaCareProviders),
                        onRowActions: _cache[1] || (_cache[1] = function (n, r, i) { return actionCareProviders(n, r, i, 'CareProviders'); }),
                        onSearch: _cache[2] || (_cache[2] = function (w, c) { return search(w, c); })
                    }, null, 8, ["data"]),
                    _createVNode(AlertModal, {
                        ref_key: "alertModal",
                        ref: alertModal
                    }, null, 512),
                    (showLoading.value)
                        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
